import _ from 'lodash'
import colors from '../settings/styleSettings'

const BeneficiaryFileStatus = {
  withError: {
    id: 1,
    color: 'orange',
    icon: 'error',
    label: 'Arquivos de outras fontes'
  },
  found: {
    id: 2,
    icon: 'check',
    color: colors.strongGreen
  },
  notFound: {
    id: 3,
    icon: 'error',
    color: colors.strongRed,
    label: 'Beneficiário não encontrado'
  },
  moreThanOneFound: {
    id: 4,
    icon: 'error',
    color: colors.strongRed,
    label: 'Mais de um beneficiário encontrado com esse nome'
  }
}

export default {
  ...BeneficiaryFileStatus,
  ..._.mapKeys(BeneficiaryFileStatus, (value) => value.id),
  list: Object.values(BeneficiaryFileStatus)
}
